module.exports = __webpack_public_path__ + "static/media/starry-night@2x.cde4224b.webp";